
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import PenaltiesSettings from './PenaltiesSettings';
import PenaltiesLog from './PenaltiesLog';

interface PenaltiesManagementProps {
  providerId: string;
}

const PenaltiesManagement = ({ providerId }: PenaltiesManagementProps) => {
  return (
    <div className="space-y-6">
      <Tabs defaultValue="settings" className="w-full">
        <TabsList className="grid w-full grid-cols-2">
          <TabsTrigger value="settings">Settings</TabsTrigger>
          <TabsTrigger value="log">Penalties Log</TabsTrigger>
        </TabsList>
        
        <TabsContent value="settings" className="space-y-6">
          <PenaltiesSettings providerId={providerId} />
        </TabsContent>
        
        <TabsContent value="log" className="space-y-6">
          <PenaltiesLog providerId={providerId} />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default PenaltiesManagement;
